import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getCrossChainLists({ commit }, params) {
    return api.crossChain
      .getList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CROSS_CHAIN, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
